import { useScrollReveal } from '@/hooks/useScrollReveal';
import classes from './Reveal.module.css';
import type { RevealProps } from './Reveal.types';

/** עוטף תוכן ומחיל עליו חשיפה הדרגתית בגלילה. */
export function Reveal({ children, delaySeconds = 0, className }: RevealProps) {
  const { ref, isRevealed } = useScrollReveal<HTMLDivElement>();
  const classNames = [classes.reveal, isRevealed ? classes.revealed : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <div
      ref={ref}
      className={classNames}
      style={{ '--reveal-delay': `${delaySeconds}s` } as React.CSSProperties}
    >
      {children}
    </div>
  );
}
